export default [
  {
    path: '/indicadores-esb',
    component: () => import('@/pages/IndicadoresEsb/Index.vue'),
  },
  {
    path: '/indicadores-esb/estrategicos',
    component: () => import('@/pages/IndicadoresEsb/Estrategicos/Index.vue'),
  },

  {
    path: '/indicadores-esb/estrategicos/atendimentos-na-esb',
    component: () =>
      import(
        '@/pages/IndicadoresEsb/Estrategicos/AtendimentosNaEsb/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-esb/estrategicos/atendimentos-na-esb',
        component: () =>
          import(
            '@/pages/IndicadoresEsb/Estrategicos/AtendimentosNaEsb/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-esb/estrategicos/criancas',
    component: () =>
      import('@/pages/IndicadoresEsb/Estrategicos/Criancas/Template.vue'),
    children: [
      {
        path: '/indicadores-esb/estrategicos/criancas',
        component: () =>
          import('@/pages/IndicadoresEsb/Estrategicos/Criancas/Index.vue'),
      },
    ],
  },
  {
    path: '/indicadores-esb/estrategicos/gestantes',
    component: () =>
      import('@/pages/IndicadoresEsb/Estrategicos/Gestantes/Template.vue'),
    children: [
      {
        path: '/indicadores-esb/estrategicos/gestantes',
        component: () =>
          import('@/pages/IndicadoresEsb/Estrategicos/Gestantes/Index.vue'),
      },
    ],
  },
  {
    path: '/indicadores-esb/ampliados',
    component: () => import('@/pages/IndicadoresEsb/Ampliados/Index.vue'),
  },
  {
    path: '/indicadores-esb/ampliados/prevencao',
    component: () =>
      import('@/pages/IndicadoresEsb/Ampliados/Prevencao/Template.vue'),
    children: [
      {
        path: '/indicadores-esb/ampliados/prevencao',
        component: () =>
          import('@/pages/IndicadoresEsb/Ampliados/Prevencao/Index.vue'),
      },
    ],
  },
  {
    path: '/indicadores-esb/ampliados/atendimentos-domiciliares',
    component: () =>
      import(
        '@/pages/IndicadoresEsb/Ampliados/AtendimentosDomiciliares/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-esb/ampliados/atendimentos-domiciliares',
        component: () =>
          import(
            '@/pages/IndicadoresEsb/Ampliados/AtendimentosDomiciliares/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-esb/ampliados/agendamentos-72h',
    component: () =>
      import('@/pages/IndicadoresEsb/Ampliados/Agendamentos72h/Template.vue'),
    children: [
      {
        path: '/indicadores-esb/ampliados/agendamentos-72h',
        component: () =>
          import('@/pages/IndicadoresEsb/Ampliados/Agendamentos72h/Index.vue'),
      },
    ],
  },
  {
    path: '/indicadores-esb/ampliados/satisfacao-do-cidadao',
    component: () =>
      import(
        '@/pages/IndicadoresEsb/Ampliados/SatisfacaoDoCidadao/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-esb/ampliados/satisfacao-do-cidadao',
        component: () =>
          import(
            '@/pages/IndicadoresEsb/Ampliados/SatisfacaoDoCidadao/Index.vue'
          ),
      },
    ],
  },
]
